import script from "./CustomToneSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomToneSelector.vue?vue&type=script&setup=true&lang=js"

import "./CustomToneSelector.vue?vue&type=style&index=0&id=7bdafb6b&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7bdafb6b"]])

export default __exports__